import { logout } from "@/services/auth.service";
import { Button } from "@/components/ui/button";

interface SessionWarningDialogProps {
  secondsLeft: number;
  onStayLoggedIn: () => void;
}

const SessionWarningDialog = ({ secondsLeft, onStayLoggedIn }: SessionWarningDialogProps) => {
  const minutes = Math.floor(secondsLeft / 60);
  const seconds = secondsLeft % 60;
  const timeDisplay = minutes > 0
    ? `${minutes}:${String(seconds).padStart(2, "0")}`
    : `${seconds}s`;

  const handleLogout = async () => {
    try {
      await logout();
    } catch {
      // Swallow logout errors — redirect always happens
    } finally {
      window.location.href = "/login";
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" />
      <div className="relative bg-background border rounded-xl shadow-xl p-6 w-full max-w-sm mx-4 space-y-4">
        <div className="space-y-1">
          <h2 className="text-lg font-semibold">Are you still there?</h2>
          <p className="text-sm text-muted-foreground">
            Your session will expire in{" "}
            <span className="font-medium tabular-nums text-foreground">{timeDisplay}</span>.
            Stay logged in?
          </p>
        </div>
        <div className="flex gap-2 justify-end">
          <Button variant="outline" size="sm" onClick={handleLogout}>
            Log out
          </Button>
          <Button size="sm" onClick={onStayLoggedIn}>
            Stay logged in
          </Button>
        </div>
      </div>
    </div>
  );
};

export default SessionWarningDialog;
